export const BUILD_VERSION = '1779373997';
